import { animate, group, query, stagger, style, transition, trigger, keyframes } from '@angular/animations';
import { RecordState } from '../../features/search/types/RecordState';

export class Animations {
  public static bid = trigger('bid', [
    transition('void => *', [
      style({
        opacity: 0,
        transform: 'translateX(-100%)'
      }),
      animate('500ms ease-in')
    ]),
    transition('* => *', [
      style({
        color: '#F00',
        opacity: 0,
        transform: 'translateX(-100%)'
      }),
      animate('500ms ease-in')
    ])
  ]);

  public static bidRow = trigger('bidRow', [
    transition(`void => ${RecordState.Success}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(115,170,0,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ]),
    transition(`void => ${RecordState.Outbid}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(255,0,0,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ]),
    transition(`void => ${RecordState.NotParticipating}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(169,169,169,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ]),
    transition(`* => ${RecordState.Success}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(115,170,0,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ]),
    transition(`* => ${RecordState.Outbid}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(255,0,0,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ]),
    transition(`* => ${RecordState.NotParticipating}`, [
      animate(700, keyframes([style({ background: 'none', offset: 0 }), style({ background: 'rgba(169,169,169,1)', offset: 0.2 }), style({ background: 'none', offset: 1 })]))
    ])
  ]);

  public static confirmBid = trigger('confirmBid', [
    transition(':enter', [
      style({
        opacity: '0'
      }),
      animate(
        '600ms ease-in',
        style({
          opacity: '1'
        })
      )
    ]),
    transition(':leave', [
      style({
        transform: 'translateX(0)',
        opacity: '1'
      }),
      animate(
        '300ms ease-out',
        style({
          transform: 'translateX(300%)',
          opacity: '0'
        })
      )
    ])
  ]);
  public static dropdown = trigger('dropdown', [
    transition(':enter', [
      style({
        opacity: '0',
        height: 0
      }),
      animate(
        '350ms ease-in',
        style({
          opacity: '1',
          height: '*'
        })
      )
    ]),
    transition(':leave', [
      style({
        opacity: '1',
        height: '*'
      }),
      animate(
        '350ms ease-out',
        style({
          opacity: '0',
          height: 0
        })
      )
    ])
  ]);

  public static fadeInFast = trigger('fadeInFast', [
    transition(':enter', [
      style({
        opacity: 0
      }),
      group([
        animate(
          '0.5s 0s ease',
          style({
            opacity: 1
          })
        )
      ])
    ])
  ]);

  public static fadeInSlow = trigger('fadeInSlow', [
    transition(':enter', [
      style({
        opacity: 0
      }),
      group([
        animate(
          '0.9s 0.9s ease',
          style({
            opacity: 1
          })
        )
      ])
    ]),
    transition(':leave', [
      style({
        opacity: 1
      }),
      group([
        animate(
          '0.1s 0.3s ease',
          style({
            opacity: 0
          })
        )
      ])
    ])
  ]);

  public static fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
      style({
        opacity: 0
      }),
      group([
        animate(
          '0.5s 0.5s ease',
          style({
            opacity: 1
          })
        )
      ])
    ]),
    transition(':leave', [
      style({
        opacity: 1
      }),
      group([
        animate(
          '0.5s 0.5s ease',
          style({
            opacity: 0
          })
        )
      ])
    ])
  ]);

  public static slowFadeIn = trigger('slowFadeIn', [
    transition('* <=> *', [
      style({
        opacity: 0
      }),
      group([
        animate(
          '0.5s ease',
          style({
            opacity: 1
          })
        )
      ])
    ])
  ]);

  public static listStagger = trigger('listStagger', [
    transition('true => false', [
      query(
        ':enter',
        [
          style({
            opacity: 0,
            transform: 'translateX(-20px)'
          }),
          stagger(
            '10ms',
            animate(
              '450ms ease-out',
              style({
                opacity: 1,
                transform: 'translateX(0px)'
              })
            )
          )
        ],
        {
          optional: true
        }
      )
    ])
  ]);

  public static tableStagger = trigger('tableStagger', [
    transition('* <=> *', [
      query(
        ':enter',
        [
          style({
            opacity: 0,
            transform: 'translateX(-20px)'
          }),
          stagger(
            '25ms',
            animate(
              '450ms ease-out',
              style({
                opacity: 1,
                transform: 'translateX(0px)'
              })
            )
          )
        ],
        {
          optional: true
        }
      )
    ])
  ]);

  public static time = trigger('time', [
    transition('* => *', [
      style({
        transform: 'translateY(-100%)'
      }),
      animate('200ms')
    ])
  ]);

  public static topAuctionsBid = trigger('topAuctionsBid', [
    transition('* => *', [
      style({
        opacity: 0,
        transform: 'translateX(-50%)'
      }),
      animate(
        '500ms ease-in',
        style({
          opacity: 1,
          transform: 'translateX(0%)'
        })
      )
    ])
  ]);
}
